import { z } from 'zod/v4';

export const BulkUpdateActionItemSchema = z.object({
  id: z.string().min(1),
  capId: z.string().min(1),
});

export const BulkUpdateActionsRequestSchema = z
  .array(BulkUpdateActionItemSchema)
  .min(1);

export type BulkUpdateActionsRequest = z.infer<
  typeof BulkUpdateActionsRequestSchema
>;

export const BulkUpdateActionsResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateActionsResponse = z.infer<
  typeof BulkUpdateActionsResponseSchema
>;
